/**
 * D3: where the intended workflow destination is parked while Keycloak takes over the URL.
 *
 * Keycloak returns its auth response in the URL fragment and strips it afterwards; with hash
 * routing the route lives in that same fragment, so it would be lost. main.ts stashes the
 * target here before Keycloak initialises and AppComponent replays it once the app is up.
 */
export const PENDING_WORKFLOW_LINK_KEY = 'pendingWorkflowLink';

/** Matches the workflow link shapes the API and the emails produce. */
export const WORKFLOW_DEEP_LINK_PATH = /^\/workflow\/(?:link|item)\/.+/;

/**
 * Keycloak appends its auth response (`code`, `state`, `session_state`, `iss`) to the URL
 * fragment — which, with hash routing, is where our route lives. Those params end up welded
 * onto the last route segment, so a link token arrives as `<token>&state=…&code=…`.
 * Strip anything from the first `&` or `?` onward.
 */
export function stripAuthResponseParams(value: string): string {
  return value.split(/[&?]/)[0];
}
